(function () {
  var selector = "[data-product-size-swatch] .size-dot[data-variant-id]:not([disabled])";
  var headerCartIconHtml = new WeakMap();

  function snapshotHeaderCartIcons() {
    document.querySelectorAll('.header--cart[data-type="icon"]').forEach(function (el) {
      if (!headerCartIconHtml.has(el) && el.querySelector("svg")) {
        headerCartIconHtml.set(el, el.innerHTML);
      }
    });
  }

  function restoreHeaderCartIconsIfClobbered() {
    document.querySelectorAll('.header--cart[data-type="icon"]').forEach(function (el) {
      // If some script replaced the SVG with the count text, restore the icon markup.
      if (!el.querySelector("svg")) {
        var original = headerCartIconHtml.get(el);
        if (original) {
          el.innerHTML = original;
        }
      }
    });
  }

  function setHeaderCartCount(count) {
    document.querySelectorAll(".header--cart[data-cart-count]").forEach(function (el) {
      el.setAttribute("data-cart-count", String(count));
    });
  }

  function getLineItemCountFromCart(cart) {
    return cart && Array.isArray(cart.items) ? cart.items.length : 0;
  }

  function hasSlideCart() {
    return (
      !!document.getElementById("slidecarthq") ||
      typeof window.SLIDECART_SET_CART === "function" ||
      typeof window.SLIDECART_UPDATE === "function"
    );
  }

  function repairHeaderCart(cart) {
    if (cart) {
      setHeaderCartCount(getLineItemCountFromCart(cart));
    }
    restoreHeaderCartIconsIfClobbered();
  }

  function syncHeaderCountFromCart() {
    fetchCart()
      .then(function (cart) {
        repairHeaderCart(cart);
      })
      .catch(function () {});
  }

  function scheduleHeaderRepair(cart) {
    [0, 100, 300, 800, 1500].forEach(function (delay) {
      window.setTimeout(function () {
        if (cart) {
          repairHeaderCart(cart);
        } else {
          syncHeaderCountFromCart();
        }
      }, delay);
    });
  }

  function scheduleHeaderCountSync() {
    window.clearTimeout(window.__sizeSwatchHeaderCountTimer);
    window.__sizeSwatchHeaderCountTimer = window.setTimeout(syncHeaderCountFromCart, 400);
    window.setTimeout(syncHeaderCountFromCart, 1200);
  }

  function bindSlideCartQuantitySync() {
    if (window.__sizeSwatchSlideCartEventsBound) return;
    window.__sizeSwatchSlideCartEventsBound = true;

    ["click", "input", "change"].forEach(function (eventName) {
      document.addEventListener(eventName, function (event) {
        if (event.target.closest("#slidecarthq")) {
          scheduleHeaderCountSync();
        }
      });
    });
  }

  function showFeedback() {
    var feedbackBar = document.querySelector("feedback-bar-element");

    if (!feedbackBar) {
      return;
    }

    if (typeof feedbackBar.load === "function") {
      feedbackBar.load("product-added");
      return;
    }

    var message = feedbackBar.querySelector(".feedback-bar--message");

    if (message) {
      message.textContent = "produto adicionado ao carrinho";
    }

    feedbackBar.setAttribute("aria-hidden", "false");
    feedbackBar.setAttribute("data-transition-active", "true");

    window.setTimeout(function () {
      feedbackBar.setAttribute("data-transition-active", "false");
      feedbackBar.setAttribute("aria-hidden", "true");
    }, 5000);
  }

  function getSections() {
    if (window.Cart && Array.isArray(window.Cart.sections)) {
      return window.Cart.sections.indexOf("cart-drawer") === -1
        ? window.Cart.sections.concat(["cart-drawer"])
        : window.Cart.sections;
    }

    return ["cart-drawer"];
  }

  function parseCartElement(html) {
    var doc = new DOMParser().parseFromString(html, "text/html");

    return (
      doc.querySelector('cart-element[data-view="drawer"]') ||
      doc.querySelector("cart-element")
    );
  }

  function escapeHtml(value) {
    var div = document.createElement("div");
    div.textContent = value == null ? "" : String(value);

    return div.innerHTML;
  }

  function formatMoney(cents) {
    return (cents / 100).toLocaleString("pt-BR", {
      style: "currency",
      currency: "BRL"
    });
  }

  async function fetchCart() {
    var response = await fetch("/cart.js", {
      headers: {
        "Cache-Control": "no-cache"
      }
    });

    if (!response.ok) {
      throw new Error(response.statusText);
    }

    return response.json();
  }

  function renderCartItem(item, index) {
    var image = item.image
      ? '<a class="cart--item--image" href="' + item.url + '" aria-label="' + escapeHtml(item.product_title) + '"><img src="' + item.image + '" alt="' + escapeHtml(item.product_title) + '" loading="lazy"></a>'
      : '<a class="cart--item--image" href="' + item.url + '" aria-label="' + escapeHtml(item.product_title) + '"></a>';
    var variantTitle = item.variant_title && item.variant_title.indexOf("Default") === -1
      ? '<div class="cart--item--variant-name" data-item="nav-text"><a href="' + item.url + '">' + escapeHtml(item.variant_title) + '</a></div>'
      : "";

    return [
      '<div class="cart--item" data-variant-id="' + item.variant_id + '" data-line-num="' + (index + 1) + '">',
      '<div class="cart--item--title"><div data-item="block-heading"><a href="' + item.url + '">' + escapeHtml(item.product_title) + '</a></div><div class="cart--error" data-item="small-text" style="display:none;"></div></div>',
      image,
      '<div class="cart--item--info">',
      variantTitle,
      '<div class="cart--item--price"><div class="cart--item--total money" data-item="nav-text">' + formatMoney(item.final_price) + '</div></div>',
      '<div class="cart--item--quantity" data-item="nav-text">Qtd: ' + item.quantity + '</div>',
      '</div>',
      '</div>'
    ].join("");
  }

  function renderCartDrawerFallback(cart) {
    var cartRoot = document.querySelector('cart-element[data-view="drawer"]');
    var cartBody = cartRoot ? cartRoot.querySelector(".cart--body") : null;
    var total = cartRoot ? cartRoot.querySelector(".cart--total-price") : null;

    if (!cartRoot || !cartBody || !cart.items || cart.items.length === 0) {
      return;
    }

    cartRoot.setAttribute("data-has-items", "true");
    cartBody.innerHTML = cart.items.map(renderCartItem).join("");

    if (total) {
      total.textContent = formatMoney(cart.total_price);
    }
  }

  function openCartDrawer() {
    // Prefer AMP Slide Cart Drawer (app), if present.
    var slideCartRoot = document.getElementById("slidecarthq");
    if (slideCartRoot) {
      // Try common public APIs first (varies by app version).
      try {
        if (typeof window.SLIDECART_OPEN === "function") {
          window.SLIDECART_OPEN();
          return;
        }
        if (window.SlideCart && typeof window.SlideCart.openCart === "function") {
          window.SlideCart.openCart();
          return;
        }
        if (window.slidecarthq && typeof window.slidecarthq.open === "function") {
          window.slidecarthq.open();
          return;
        }
      } catch (e) {}

      // DOM-based fallback: toggle open classes used by the app.
      var overlay = slideCartRoot.querySelector(".slidecarthq-overlay");
      var panel = slideCartRoot.querySelector(".slidecarthq");
      if (overlay) overlay.classList.add("open");
      if (panel) panel.classList.add("open");

      // Some versions listen to refresh/open events.
      window.dispatchEvent(new Event("slidecart:open"));
      window.dispatchEvent(new Event("slidecart:refresh"));
      document.dispatchEvent(new Event("slidecart:open"));
      document.dispatchEvent(new Event("slidecart:refresh"));
      return;
    }

    var drawer = document.querySelector("drawer-element");
    if (drawer && typeof drawer.open === "function") {
      drawer.open("right", "cart-drawer", null);
    }
  }

  async function syncSlideCart(cart) {
    var slideCartRoot = document.getElementById("slidecarthq");
    if (!slideCartRoot) return false;

    try {
      if (typeof window.SLIDECART_SET_CART === "function") {
        window.SLIDECART_SET_CART(cart);
      }
      if (typeof window.SLIDECART_UPDATE === "function") {
        window.SLIDECART_UPDATE(cart);
      }
      // Keep header counter aligned with line items shown in drawer.
      scheduleHeaderRepair(cart);
      return true;
    } catch (e) {
      return false;
    }
  }

  async function refreshCartDrawer() {
    var root = (window.Shopify &&
      window.Shopify.routes &&
      window.Shopify.routes.root) || "/";

    var response = await fetch(root + "?sections=cart-drawer", {
      headers: {
        "Cache-Control": "no-cache"
      }
    });

    if (!response.ok) {
      return;
    }

    var sections = null;
    var html = null;

    try {
      sections = await response.json();
      html = sections && sections["cart-drawer"];
    } catch (e) {
      try {
        html = await response.text();
      } catch (err) {
        return;
      }
    }

    if (!html) {
      return;
    }

    var currentContainer = document.querySelector('.drawer--container[data-view="cart-drawer"]');
    var currentCart = document.querySelector('cart-element[data-view="drawer"]');
    var freshCart = parseCartElement(html);

    if (currentContainer && freshCart) {
      currentContainer.innerHTML = "";
      currentContainer.appendChild(freshCart);
    } else if (currentCart && freshCart) {
      currentCart.replaceWith(freshCart);
    }

    if (window.Cart && typeof window.Cart.fetchTotals === "function") {
      await window.Cart.fetchTotals();
    }

    var cart = await fetchCart();
    var drawerHasItems = document.querySelector('cart-element[data-view="drawer"] .cart--item');

    if (!drawerHasItems && cart.items && cart.items.length > 0) {
      renderCartDrawerFallback(cart);
    }
  }

  function getCartAddUrl() {
    if (window.Shopify && window.Shopify.routes && window.Shopify.routes.cart_add) {
      return window.Shopify.routes.cart_add + ".js";
    }

    if (window.routes && window.routes.cart_add_url) {
      return window.routes.cart_add_url + ".js";
    }

    return "/cart/add.js";
  }

  async function updateCartCountFallback() {
    var response = await fetch("/cart.js");

    if (!response.ok) {
      return;
    }

    var cart = await response.json();
    // Use line items count (drawer items) instead of total quantity.
    var count = getLineItemCountFromCart(cart);
    // Don't target generic [data-cart-count] (apps may also use it).
    // Theme header cart uses `.header--cart[data-cart-count]`.
    setHeaderCartCount(count);

    // Some scripts incorrectly overwrite the icon with text; keep the SVG.
    restoreHeaderCartIconsIfClobbered();
  }

  async function addVariantToCart(button) {
    var variantId = parseInt(button.dataset.variantId, 10);

    if (!variantId || button.getAttribute("aria-busy") === "true") {
      return;
    }

    var request = {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        items: [
          {
            id: variantId,
            quantity: 1
          }
        ],
        sections: getSections()
      })
    };

    button.setAttribute("aria-busy", "true");

    try {
      if (hasSlideCart()) {
        var slideCartResponse = await fetch(getCartAddUrl(), request);

        if (!slideCartResponse.ok) {
          throw new Error(slideCartResponse.statusText);
        }
      } else if (window.Cart && typeof window.Cart.addItems === "function") {
        await window.Cart.addItems(request, variantId);
        await refreshCartDrawer();
      } else {
        var response = await fetch(getCartAddUrl(), request);

        if (!response.ok) {
          throw new Error(response.statusText);
        }

        await updateCartCountFallback();
        await refreshCartDrawer();
      }

      // Garantia: se o tema não re-renderizar o drawer via sections/eventos,
      // renderizamos via /cart.js para o item aparecer imediatamente.
      try {
        var cart = await fetchCart();
        await syncSlideCart(cart);
        renderCartDrawerFallback(cart);
        scheduleHeaderRepair(cart);
      } catch (e) {}

      showFeedback();
    } catch (error) {
      console.error("Erro ao adicionar produto pelo tamanho:", error);
    } finally {
      button.setAttribute("aria-busy", "false");
    }
  }

  document.addEventListener("click", function (event) {
    var button = event.target.closest(selector);

    if (!button) {
      return;
    }

    event.preventDefault();
    addVariantToCart(button);
  });

  // Capture original icon markup ASAP.
  snapshotHeaderCartIcons();
  bindSlideCartQuantitySync();
  document.addEventListener("DOMContentLoaded", snapshotHeaderCartIcons);
  document.addEventListener("DOMContentLoaded", bindSlideCartQuantitySync);
})();
